
export class InterventionsLookup {

    static GetYesNoUnknown(value: number): string {
        switch (value) {
            case 0: return "No";
            case 1: return "Yes";
            default: return "Unknown";
        }
    }

    static GetInterventionStatus(value: number): string {
        switch (value) {
            case 0: return "Never started";
            case 1: return "Discontinued Early";
            case 2: return "Completed (Full course)";
            case 3: return "Completed (Incomplete dose(s)/session(s))";
            case 4: return "Ongoing";
            case 5: return "Unknown/Pending";
            default: return ""; 
        }
    }

    static GetStudyStatus(value: number): string {
        switch (value) {
            case 0: return "Discontinued early";
            case 1: return "In Treatment";
            case 2: return "In follow-up";
            case 3: return "Unknown"; 
            case 4: return "Treatment Status Unknown/Pending";
            case 5: return "Completed Study";
            default: return ""; 
        }
    }

    static GetDnsInterventionReason(value: number): string {
        switch (value) {
            case 1: return "Clinical deterioration";
            case 2: return "Confirmed new case of acute SARS-CoV-2";
            case 3: return "Intervention logistics (study drug kit not delivered, destroyed, lost… etc.)";
            case 4: return "Investigator decision";
            case 5: return "Participant concerns";
            case 6: return "Participant ended study prior to administration";
            case 7: return "Participant study intervention non-compliance";
            case 8: return "SAEs";
            case 9: return "Other";
            case 10: return "Unknown";
            default: return ""; 
        }
    }

    static GetDisconInterventionReason(value: number): string {
        switch (value) {
            case 1: return "AE/SAE";
            case 2: return "Clinical deterioration";
            case 3: return "Confirmed new case of acute SARS-CoV-2";
            case 4: return "Investigator decision";
            //case 5: return "Participant concerns";
            //case 6: return "Participant ended study early";
            case 7: return "Participant study intervention non-compliance";
            //case 8: return "PEM/Worsening PEM";
            //case 9: return "UADE/AE/SAE";
            case 10: return "Other";
            case 11: return "Unknown";
            case 12: return "Participant choice";
            default: return ""; 
        }
    }

    static GetDisconReasonFormattedForTable(value: number): string {
        switch (value) {
            case 1: return "AE/SAE";
            case 2: return "Clinical<br/> deterioration";
            case 3: return "Confirmed new<br/>case of acute<br/>SARS-CoV-2";
            case 4: return "Investigator<br/>decision";
            //case 5: return "Participant concerns";
            //case 6: return "Participant ended study early";
            case 7: return "Participant<br/>study intervention<br/>non-compliance";
            //case 8: return "PEM/Worsening PEM";
            //case 9: return "UADE/AE/SAE";
            case 10: return "Other";
            case 11: return "Unknown";
            case 12: return "Participant<br/>choice";
            default: return "";
        }
    }

    static GetDncInterventionReasonForTable(value: number): string {
        switch (value) {
            case 8: return "Participant<br/>study intervention</br>non-compliance";
            case 12: return "Other";
            case 13: return "Unknown";
            case 16: return "Participant<br/>choice";
            case 17: return "AE/SAE<br/>and/or<br/>Clinical<br/>deterioration";
            default: return ""; 
        }
    }

    static GetDncInterventionReason(value: number): string {
        switch (value) {
            //case 1: return "AE/SAE";
            //case 2: return "Clinical deterioration";
            case 3: return "Confirmed new case of acute SARS-CoV-2";
            case 4: return "Forgot";
            case 5: return "Investigator decision";
            case 6: return "Lack of time";
            //case 7: return "Participant concerns";
            case 8: return "Participant study intervention non-compliance";
            case 9: return "PEM/Worsening PEM";
            case 10: return "Too tired";
            case 11: return "UADE/AE/SAE";
            case 12: return "Other";
            case 13: return "Unknown";
            //case 14: return "AE, PEM, and/or Clinical deterioration";
            case 15: return "Participant ended study early";
            case 16: return "Participant choice";
            case 17: return "AE/SAE and/or Clinical deterioration";
            default: return "";
        }
    }

    static GetDncStudyReason(value: number): string {
        switch (value) {
            case 1: return "AE/SAE";
            case 2: return "Death";
            case 3: return "Disease Relapse or Recurrent Disease";
            //case 4: return "Failure to Meet Randomization Criteria";
            case 5: return "Lost to Follow-up";
            case 6: return "Non-compliance with Intervention";
            case 7: return "Physician Decision";
            case 8: return "Pregnancy";
            case 9: return "Progressive Disease";
            case 10: return "Post Exertional Malaise (PEM)";
            case 11: return "Protocol Violation";
            case 12: return "Recovery";
            case 13: return "Screen Failure";
            case 14: return "Site Terminated by Study Sponsor";
            case 15: return "Terminated by Sponsor";
            case 16: return "Technical Problems (Protocol specific issues)";
            case 17: return "Intervention logistics (study drug kit not delivered, destroyed, lost… etc.)";
            case 18: return "Withdrawn Consent";
            //case 19: return "Not eligible for any appendices";
            case 20: return "Other";
            case 21: return "Unknown";
            case 22: return "Ineligible for study";
            default: return "";

        }
    }

    static GetInterventionOrdering(value: number): number {
        switch (value) {
            default: return 100; //default ordering
        }
    }

    static GetColorIndex(id: number): number {
        switch (id) {
            case (2): return 500; //completed (full course)
            case (3): return 506; //Completed (Incomplete dose(s)/sessions(s))
            case (4): return 501; //Ongoing
            case (0): return 504; //Never Started
            case (1): return 503; //Discontinued Prior
            default: return 502;
        }
    }
}